var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFileLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1499 23.3996H8.5499C6.39599 23.3996 4.6499 21.6535 4.6499 19.4996V6.49961C4.6499 4.3457 6.39599 2.59961 8.5499 2.59961H17.6499C19.8038 2.59961 21.5499 4.3457 21.5499 6.49961V9.74961M16.9999 16.2496V14.9496C16.9999 13.8727 17.8729 12.9996 18.9499 12.9996C20.0269 12.9996 20.8999 13.8727 20.8999 14.9496V16.8996M16.9999 7.79961H8.5499M13.0999 11.6996H8.5499M11.1499 15.5996H8.5499M16.3499 23.3996H21.5499C22.2679 23.3996 22.8499 22.8176 22.8499 22.0996V18.1996C22.8499 17.4816 22.2679 16.8996 21.5499 16.8996H16.3499C15.6319 16.8996 15.0499 17.4816 15.0499 18.1996V22.0996C15.0499 22.8176 15.6319 23.3996 16.3499 23.3996Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFileLock);
export default __webpack_public_path__ + "static/media/icon-file-lock.1b3e7314361e05d69d66270b44a9f11e.svg";
export { ForwardRef as ReactComponent };